/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Carousel_PickInputs */

const da_forside_carousel_pick = /** @type {(inputs: Forside_Carousel_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg citat`)
};

/** @type {(inputs: Forside_Carousel_PickInputs) => LocalizedString} */
const en_forside_carousel_pick = da_forside_carousel_pick;

/**

* @param {Forside_Carousel_PickInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_pick = /** @type {((inputs?: Forside_Carousel_PickInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_PickInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_pick(inputs)
	return /** @type {LocalizedString} */ ("Vælg citat")
});